import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import Equipment from './components/Equipment';
import References from './components/References';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import ScrollToTop from './components/ScrollToTop';

const Home = () => (
  <main>
    <Hero />
    <Stats />
    <About />
    <Services />
    <Equipment />
    <References />
    <Contact />
  </main>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white selection:bg-amber-500 selection:text-slate-900">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;